import { notificacaoErro } from "../app/notificacao";

async function fetchAtualizaDepartamento(nome, token, departamentoId) {
  const url = new URL(process.env.REACT_APP_API_URL + "/departamento/" + departamentoId);
  const init = {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify({ nome }),
  };

  const fet = await fetch(url, init);

  switch (fet.status) {
    case 200:
      return { success: true, status: fet.status, data: await fet.json() };
    case 404:
      return {
        success: false,
        status: fet.status,
        error: notificacaoErro(fet, init, "Ocorreu um erro ao atualizar o departamento."),
      };
    default:
      return {
        success: false,
        status: fet.status,
        error: notificacaoErro(fet, init, "Ocorreu um erro inesperado ao atualizar o departamento."),
      };
  }
}

const atualizaDepartamento = { fetchAtualizaDepartamento };

export default atualizaDepartamento;
